import type { CtasAliasOverridesEntryValue } from '../types/configs.generated';
import {
    getBaseLanguage,
    normalizeLocaleCode,
    normalizeLocaleRecord,
} from '../utils/content/localeUtils';

export type CtaAliasOverrides = Record<string, Record<string, CtasAliasOverridesEntryValue>>;

function normalizeDomainKey(domain: string): string {
    return domain.trim().toLowerCase().replace(/\.$/, '');
}

export function getCtaAliasOverride(
    aliasOverrides: CtaAliasOverrides | null | undefined,
    domain: string,
    ctaId: string
): CtasAliasOverridesEntryValue | undefined {
    if (!aliasOverrides) return undefined;

    const normalizedDomain = normalizeDomainKey(domain);
    const domainEntry = Object.entries(aliasOverrides).find(
        ([candidate]) => normalizeDomainKey(candidate) === normalizedDomain
    )?.[1];

    return domainEntry?.[ctaId];
}

/** Resolve one localized CTA field using exact locale, then base language. */
export function resolveCtaLocaleValue(
    values: Record<string, string> | null | undefined,
    locale: string
): string | undefined {
    const normalizedLocale = normalizeLocaleCode(locale);
    if (!normalizedLocale) return undefined;

    const normalizedValues = normalizeLocaleRecord(values);
    const baseLanguage = getBaseLanguage(normalizedLocale);
    const candidates = [normalizedLocale];
    if (baseLanguage && baseLanguage !== normalizedLocale) candidates.push(baseLanguage);

    for (const candidate of candidates) {
        if (normalizedValues[candidate] !== undefined) {
            return normalizedValues[candidate];
        }
    }

    return undefined;
}
